module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-24-cd164c1b680ff4e5d577d9ed2c8d0cd3.jpg";